import React, { useState } from 'react';
import { Platform, View } from 'react-native';
import styled from 'styled-components/native';
import _ from 'lodash';
import Map from './Map';
import { niceRound } from '../Things';
import { FlexBlockWrapped, BasicText, FlexElement, StrongText, Loading, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading, PageWrapper } from '../Styles';
import { List } from '../core/List';
import OpidLink from '../core/OpidLink';
import AddressBlock from '../core/AddressBlock';
import { useOpidNavigator } from '../core/OpidNavigator';
import Util from '../core/Util';

const Format = {
    asCurrency: (val) => {
        return parseFloat(val).toLocaleString('en-us', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    }
};

const SiteChunk = styled.View`
    min-height: 67px;
`;

const SiteBlock = ({ path, children = undefined }) => {
    return <SiteChunk>
        <OpidLink path={path}>{children}</OpidLink>
    </SiteChunk>;
};

const ListSites = ({ portalData }) => {
    const [page, setPage] = useState(0);
    const navigation = useOpidNavigator();

    if (portalData.sites == null){
        return null;
    }

    const navigateToSite = (siteMarker) => {
        const site = _.find(portalData.sites, {name: siteMarker[2]});
        if(site != undefined){
            navigation.goto("/site/" + site.site_id);
        } else {
            debugger;
        }
    }
      
    const uniqueSites = _.sortBy(_.uniqBy(portalData.sites, "site_id"), ["province", "name"]);
    const resultsPerPage = 8;

    const mapMarkers = _.map(uniqueSites, (site)=>{  return [site.map_lat, site.map_long, site.name] } );

    return <PageWrapper>
        <ShinyBlockOuter minHeight={400} flexBasis="99%">
            <ShinyHeading>
                <MetricStackTitle>{"Sites"}</MetricStackTitle>
            </ShinyHeading>
            <ShinyBody>
                <FlexBlockWrapped>
                    <List data={uniqueSites} resultsPerPage={resultsPerPage} initialPage={page} pageSetter={(pageNum)=>setPage(pageNum)} style={{flex: 1, flexDirection: "column", justifyContent: "space-between"}}>
                        { (site)=> <SiteBlock path={"/site/" + site.site_id}>
                            <AddressBlock title={site.name} address={site.address} city={site.city} postalCode={site.postal_code} province={site.province} country={site.country} />
                        </SiteBlock> }
                    </List>
                    <FlexElement flex={Util.isMobile()? 0: 2}>
                        <Map markers={ mapMarkers } onClickEvent={(a)=>navigateToSite(a)} height={500}/>
                    </FlexElement>
                </FlexBlockWrapped>
            </ShinyBody>
        </ShinyBlockOuter>
    </PageWrapper>;
}

export default ListSites;